export default function Mastercard(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={24} {...props}>
      <g data-name="master card logo">
        <path fill="#ff5f00" d="M18.807 2.528H29.15v18.944H18.807z" />
        <path
          d="M19.363 11.998a12.1 12.1 0 0 1 4.5-9.434 11.642 11.642 0 0 0-7.29-2.566 12 12 0 0 0 0 24 11.641 11.641 0 0 0 7.29-2.567 12.047 12.047 0 0 1-4.5-9.433Z"
          fill="#eb001b"
        />
        <path
          d="M43.204 11.998a11.9 11.9 0 0 1-11.82 12 11.639 11.639 0 0 1-7.29-2.567 12.14 12.14 0 0 0 0-18.866 11.64 11.64 0 0 1 7.29-2.566 11.924 11.924 0 0 1 11.82 11.999Z"
          fill="#f79e1b"
        />
      </g>
    </svg>
  );
}
